import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../../../../components/buttons/button";
import { ProfileIcon } from "../../../../components/cards/profilePic";
import { SearchInput } from "../../../../components/inputs/searchInput";
import { Pill } from "../../../../components/pill";
import { TableComponent } from "../../../../components/table";
import { BgWrapper } from "../../../../components/wrapper/bgWrapper";
import { useGetSalesAgentOrganizersQuery } from "../../../../redux/features/admin/sales/sales.api";
import { SalesAgentOrganizersQuery } from "../../../../redux/features/admin/sales/sales.types";
import { userStatusPillMap } from "../../../../utils/constants";

export const LinkedOrganizers = ({ agentId }: { agentId: string }) => {
  const [query, setQuery] = useState<SalesAgentOrganizersQuery>({
    id: agentId,
    page: 1,
    limit: 20,
    sortOrder: "asc",
  });

  const { data: agentOrganizers, isFetching: loadingAgentOrganizers } =
    useGetSalesAgentOrganizersQuery(
      {
        ...query,
      },
      { refetchOnMountOrArgChange: true },
    );
  return (
    <>
      <BgWrapper className="flex flex-col gap-3 rounded-t-none">
        <div className="flex w-full flex-col items-center justify-between gap-4 md:flex-row">
          <SearchInput
            searchFunction={(value) => {
              setQuery({
                ...query,
                search: value || undefined,
                page: 1,
              });
            }}
            placeholder="Search"
            className="md:!max-w-[300px]"
          />

          <div className="grid w-full grid-cols-2 items-center gap-3 md:flex md:w-fit md:flex-row">
            <Button
              type="button"
              onClick={() => {
                if (query.sortOrder === "asc") {
                  setQuery({ ...query, sortOrder: "desc" });
                } else {
                  setQuery({ ...query, sortOrder: "asc" });
                }
              }}
              text="Date Modified"
              className="!min-w-fit !rounded-2xl !p-3 !text-sm"
              icon={query.sortOrder === "asc" ? "order-asc" : "order-desc"}
              variation="grey"
            />

            <Button
              type="button"
              onClick={async () => {
                // await exportData({
                //   type: "users",
                //   fetchAll: true,
                //   sortOrder: query.sortOrder,
                //   search: query.search || undefined,
                //   searchTerm: query.search || undefined,
                // });
              }}
              text="Export"
              className="!min-w-fit !rounded-2xl !p-3 !text-sm"
              icon="export"
              variation="grey"
              //   loading={exportingData}
            />
          </div>
        </div>

        <TableComponent
          headers={[]}
          rows={
            agentOrganizers?.data?.data?.map((user) => {
              return {
                id: user._id,
                items: [
                  <div
                    className={`flex w-full flex-1 flex-col gap-2 md:flex-row md:items-center`}
                  >
                    <div className="flex items-center justify-between gap-2">
                      <ProfileIcon img="" dimension={32} className="" />
                    </div>

                    <Link
                      to={`/users/${user._id}`}
                      className="flex flex-1 flex-wrap items-center gap-0 text-sm text-grey-600"
                    >
                      <span className="font-bold text-grey-900">
                        {user.name}
                      </span>
                      <span className={` `}>∙</span>
                      <span className={``}>{user.email}</span>
                    </Link>

                    <div className="flex flex-row flex-wrap items-center gap-2">
                      <Pill text={"ORGANIZER"} variation={"purple"} />
                      {user.organizerType === "Business" && (
                        <Pill text={"COMPANY"} variation={"grey"} />
                      )}
                      {!user.subAccountIsVerified ? (
                        <Pill text={"UNVERIFIED SA"} variation={"grey"} />
                      ) : undefined}
                      <Pill
                        text={userStatusPillMap[user.status]?.text}
                        variation={userStatusPillMap[user.status]?.variant}
                      />
                    </div>
                  </div>,
                ],
              };
            }) ?? []
          }
          emptyImage="/assets/images/guest-glass.png"
          emptyTitle="No Linked Organizers"
          isTableEmpty={[0, undefined].includes(
            agentOrganizers?.data?.data?.length,
          )}
          isPaginated
          itemsPerPage={query.limit}
          isLoading={loadingAgentOrganizers}
          currentPage={query.page}
          totalCount={agentOrganizers?.data?.totalCount}
          onPageChange={(page) => {
            setQuery({
              ...query,
              page,
            });
          }}
        />
      </BgWrapper>
    </>
  );
};
